<template>
  <div
    class="content content-dashboard w-100 h-100 d-flex justify-content-center align-items-center flex-column position-relative">
    <div class="row content-body dashboard-body align-items-center">
      <div class="col-lg-12">
        <p class="title mt-3 mb-3">Ma commande</p>
        <p class="sub-title-info">Je finalise ma commande en suivants les etapes ci-dessous</p>

        <div class="row step-cart">
          <div class="col-lg-11 col-md-11 col-sm-11 d-flex justify-content-center">
            <div class="d-flex gap-4 align-items-center py-4 step-cart-centent">

              <div class="step-number">
                <span class="badge mx-2">
                  <svg xmlns="http://www.w3.org/2000/svg" class="w-100 h-75" fill="none" viewBox="0 0 24 24"
                    stroke="#ec621a" stroke-width="3">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                </span>
                <span class="step-title">Votre panier</span>
              </div>

              <div class="separator"></div>

              <div class="step-number">
                <span class="badge mx-2">
                  <svg xmlns="http://www.w3.org/2000/svg" class="w-100 h-75" fill="none" viewBox="0 0 24 24"
                    stroke="#ec621a" stroke-width="3">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                </span>
                <span class="step-title">Mode de livraison</span>
              </div>

              <div class="separator"></div>


              <div class="step-number">
                <span class="badge mx-2">
                  <svg xmlns="http://www.w3.org/2000/svg" class="w-100 h-75" fill="none" viewBox="0 0 24 24"
                    stroke="#ec621a" stroke-width="3">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                </span>
                <span class="step-title">Adresse</span>
              </div>

              <div class="separator"></div>

              <div class="step-number">
                <span class="badge mx-2">3</span>
                <span class="step-title">Validation</span>
              </div>

            </div>
          </div>
        </div>

        <div v-if="isLoading" class="text-center">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          Chargement des vétérinaires...
        </div>
        <div v-else-if="errorMessage" class="alert alert-error">
          <span class="error-message">{{ errorMessage }}</span>
        </div>
        <div v-else-if="veterinarians.length === 0" class="text-center">
          <p>Aucun vétérinaire trouvé.</p>
        </div>
        <div v-else class="row justify-content-center">
          <div class="col-lg-10">
            <div class="veterinarian-list">
              <div class="table-info mb-2">
                <span class="text-muted small">
                  {{ filteredVeterinarians.length }} résultat(s) sur {{ veterinarians.length }}
                </span>
              </div>
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th>Code Divalto</th>
                    <th>Titre</th>
                    <th>Raison Sociale</th>
                    <th>Email</th>
                    <th>Téléphone</th>
                    <th>Code Postal</th>
                    <th>Ville</th>
                    <th>Statut</th>
                    <th>Action</th>
                  </tr>
                  <tr>
                    <th>
                      <input v-model="filters.divalto_id" type="text" class="form-control form-control-sm"
                        placeholder="Filtrer..." />
                    </th>
                    <th>
                      <input v-model="filters.gender" type="text" class="form-control form-control-sm"
                        placeholder="Filtrer..." />
                    </th>
                    <th>
                      <input v-model="filters.fullName" type="text" class="form-control form-control-sm"
                        placeholder="Filtrer..." />
                    </th>
                    <th>
                      <input v-model="filters.email" type="text" class="form-control form-control-sm"
                        placeholder="Filtrer..." />
                    </th>
                    <th>
                      <input v-model="filters.phoneNumber" type="text" class="form-control form-control-sm"
                        v-only-digits placeholder="Filtrer..." />
                    </th>
                    <th>
                      <input v-model="filters.postcode" type="text" class="form-control form-control-sm"
                        v-only-digits placeholder="Filtrer..." />
                    </th>
                    <th>
                      <input v-model="filters.city" type="text" class="form-control form-control-sm"
                        placeholder="Filtrer..." />
                    </th>
                    <th>
                      <input v-model="filters.status" type="text" class="form-control form-control-sm"
                        placeholder="Filtrer..." />
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="vet in paginatedVeterinarians" :key="vet.id">
                    <td>{{ vet.divalto_id || '-' }}</td>
                    <td>{{ vet.gender || '-' }}</td>
                    <td>{{ vet.fullName || '-' }}</td>
                    <td>{{ vet.email || '-' }}</td>
                    <td>{{ vet.phoneNumber || '-' }}</td>
                    <td>{{ vet.adressesFacturation?.postcode || '-' }}</td>
                    <td>{{ vet.adressesFacturation?.city || '-' }}</td>
                     <td class="status-cell">
                      <span class="status-dot" :style="{ backgroundColor: vet.status?.color  }"></span>
                    </td>
                    <td>
                      <button class="btn btn-cart" @click="viewCart(vet)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#ec621a"
                          viewBox="0 0 24 24">
                          <path
                            d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49A1.003 1.003 0 0 0 20 4H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z" />
                        </svg>
                      </button>
                    </td>
                  </tr>
                  <tr v-if="paginatedVeterinarians.length === 0">
                    <td colspan="9" class="text-center text-muted">Aucun résultat.</td>
                  </tr>
                </tbody>
              </table>
              <!-- Pagination -->
              <div class="pagination-bar">
                <span class="pagination-info">Page {{ currentPage }} / {{ totalPages }}</span>
                <div class="pagination-controls">
                  <button class="btn-page" :disabled="currentPage === 1" @click="currentPage--">&#8592; Précédent</button>
                  <button class="btn-page" :disabled="currentPage === totalPages" @click="currentPage++">Suivant &#8594;</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { getVeterinarians } from "@/api/Delegate";
import logo from "@/assets/images/2_LOGO - COULEURS-bg-b.png";
import { useDelegueStore } from "@/stores/delegueStore"; 
import { useCartStore } from '@/stores/cartStore';

export default {
  name: "DelegueDashboard",
  data() {
    return {
      logo,
      veterinarians: [],
      isLoading: false,
      errorMessage: null,
      currentPage: 1,
      pageSize: 50,
      filters: {
        divalto_id: '',
        gender: '',
        fullName: '',
        email: '',
        phoneNumber: '',
        postcode: '',
        city: '',
        status: '',
      },
    };
  },
  created() {
    this.delegueStore = useDelegueStore(); 
  },
  computed: {
    filteredVeterinarians() {
      return this.veterinarians.filter(vet => {
        // Helper: match a field value against a filter term.
        // If the field is null/undefined and the user typed a filter, exclude the row.
        // If the filter is empty, always include the row.
        const match = (value, filter) => {
          if (!filter) return true;
          if (value == null) return false;
          return String(value).toLowerCase().includes(filter.toLowerCase());
        };

        return (
          match(vet.divalto_id, this.filters.divalto_id) &&
          match(vet.gender, this.filters.gender) &&
          match(vet.fullName, this.filters.fullName) &&
          match(vet.email, this.filters.email) &&
          match(vet.phoneNumber, this.filters.phoneNumber) &&
          match(vet.adressesFacturation?.postcode, this.filters.postcode) &&
          match(vet.adressesFacturation?.city, this.filters.city) &&
          match(this.getStatusState(vet.status), this.filters.status)
        );
      });
    },
    totalPages() {
      return Math.ceil(this.filteredVeterinarians.length / this.pageSize) || 1;
    },
    paginatedVeterinarians() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.filteredVeterinarians.slice(start, start + this.pageSize);
    },
  },
  watch: {
    // Reset to page 1 whenever any filter changes
    filters: {
      deep: true,
      handler() {
        this.currentPage = 1;
      },
    },
  },
  mounted() {
    this.fetchVeterinarians();
  },
  methods: {
    async fetchVeterinarians() {
      this.isLoading = true;
      this.errorMessage = null;
      try {
        this.veterinarians = await getVeterinarians();
      } catch (error) {
        this.errorMessage = error.message || "Une erreur est survenue lors du chargement des données.";
      } finally {
        this.isLoading = false;
      }
    },
    async viewCart(vet) {

      await useCartStore().clearCart();
      await useCartStore().reintializeCart();

      await this.delegueStore.setSelectedVeterinarian(vet);
      await useCartStore().createCart();
      this.$router.push("/cart");
    
    },
    getStatusState(status) {
      if (!status || typeof status !== 'string') return '';
      const match = status.match(/\/api\/v2\/customer-statuses\/(\d+)/);
      return match ? match[1] : '';
    },
  },
};
</script>

<style scoped>
.dashboard-body {
  position: relative;
  height: 100%;
}

.logo-top {
  text-align: end;
}

.logo {
  width: 170px;
  height: 35px;
}

.title {
  color: #1e347d;
  font-size: 22px;
  font-weight: bold;
  text-align: center;
  line-height: 29px;
}

.sub-title-info {
  color: #515a6e;
  font-size: 16px;
  text-align: center;
  line-height: 24px;
}

.veterinarian-list {
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 2px solid #aeb1ba;
  border-radius: 10px;
  padding: 20px;
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.table th,
.table td {
  padding: 10px;
  text-align: left;
  border: 1px solid #aeb1ba;
}

.table th {
  background-color: #c9cfde;
  color: #1e347d;
  font-weight: bold;
}

.table td {
  color: #1e347d;
}

.alert-error {
  background-color: #ffefe6;
  border: 1px solid #ffb08f;
  border-radius: 4px;
  color: #515a6e;
  font-size: 18px;
  line-height: 16px;
  margin-bottom: 10px;
  padding: 10px;
  text-align: center;
}

.error-message {
  color: red;
  margin-left: 8px;
}

@media (max-width: 991.98px) {
  .dashboard-body {
    padding: 0 10px;
  }
}

@media (max-width: 767.98px) {
  .title {
    font-size: 18px;
    line-height: 24px;
  }

  .logo {
    width: 120px;
    height: 28px;
  }

  .veterinarian-list {
    padding: 10px;
  }

  .table th,
  .table td {
    font-size: 14px;
    padding: 8px;
  }

  .content-dashboard {
    padding: 0 5px;
  }

  .col-lg-10,
  .col-lg-12 {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }


}

.status-green {
  background-color: green;
}

.status-red {
  background-color: red;
}

.status-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-left: 50%;
}

.pagination-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
  padding: 0 4px;
}

.pagination-info {
  font-size: 13px;
  color: #515a6e;
}

.pagination-controls {
  display: flex;
  gap: 8px;
}

.btn-page {
  display: inline-flex;
  align-items: center;
  padding: 5px 14px;
  font-size: 13px;
  font-weight: 500;
  border: 1px solid #1e347d;
  border-radius: 6px;
  background: #ffffff;
  color: #1e347d;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}

.btn-page:hover:not(:disabled) {
  background: #1e347d;
  color: #ffffff;
}

.btn-page:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
</style>
